__turbopack_context__.v({
  "className": "avertaregular_305dffb0-module__Cwwkcq__className",
  "variable": "avertaregular_305dffb0-module__Cwwkcq__variable",
});
